var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"full-height",attrs:{"fluid":""}},[(_vm.$hasPermissionTo(['generate probation report']))?_c('report-probation-probation-report',{staticClass:"mb-2"}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }